export default "__VITE_ASSET__ed948723__"